import { render, staticRenderFns } from "./SelectCopy.vue?vue&type=template&id=79725266&"
import script from "./SelectCopy.vue?vue&type=script&lang=js&"
export * from "./SelectCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79725266')) {
      api.createRecord('79725266', component.options)
    } else {
      api.reload('79725266', component.options)
    }
    module.hot.accept("./SelectCopy.vue?vue&type=template&id=79725266&", function () {
      api.rerender('79725266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/subjects/SelectCopy.vue"
export default component.exports